import { useTooltip } from "context/TooltipProvider";
import { FC, useState } from "react";
import { editPrivateProsecution } from "services/privateProsecutionService";
import { PrivateProsecution } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandlerOnForm } from "utils/helper";

type Props = {
  privateProsecution: PrivateProsecution;
  setRefetch: (refetch: boolean) => void;
  onClose: () => void;
};

const RegistrarForm: FC<Props> = ({
  privateProsecution,
  setRefetch,
  onClose,
}) => {
  const { showTooltip } = useTooltip();
  const [formState, setFormState] = useState<{
    registaration_number?: string;
    registration_date?: Date;
  }>({
    registaration_number: "",
    registration_date: new Date(),
  });
  const [loading, setLoading] = useState(false);
  // const [adminUnitDetail, setAdminUnitDetail] = useState<any>();

  // useEffect(() => {
  //   if (instruction) {
  //     fetchAdminUnitDetail(
  //       instruction?.admin_unit_id,
  //       instruction?.org_id,
  //     ).then((data) => {
  //       if (data) {
  //         setAdminUnitDetail(data);
  //       }
  //     });
  //   }
  // }, [instruction]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    // if (!formState.registrar_refernece_out) return "Reference Out is Required.";

    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }

    setLoading(true);

    editPrivateProsecution({
      ...formState,
      id: privateProsecution.id,
      forwarding_status: "forwarded_to_indvdual",
    })
      .then(() => {
        showTooltip("Successful!", "success");
        setFormState({});
        setRefetch(true);
      })
      .catch((error) => {
        showTooltip(
          error?.response?.data?.detail || errorHandlerOnForm(error),
          "error",
        );
      })
      .finally(() => {
        setLoading(false);
        onClose();
      });
  };

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose();
    }
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="relative w-full max-w-xl bg-white p-8 shadow-lg rounded-lg overflow-y-auto">
        <h2 className="mb-1 text-2xl font-semibold">Registration</h2>
        <p className="mb-6 text-xs font-light text-[#9D9D9D]">
          Please fill in the registration details for this private prosecution.
        </p>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-2 gap-x-4 mt-4">
            <div className="flex flex-col mt-4 w-full">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Registration Number
              </label>
              <input
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="registaration_number"
                value={formState?.registaration_number || ""}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col mt-4 w-full">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Registration Date
              </label>
              <input
                type="date"
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="registration_date"
                value={
                  formState?.registration_date
                    ? new Date(formState.registration_date)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="mt-6 flex justify-between gap-2">
            <button
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded w-full hover:bg-gray-300"
              onClick={onClose}
              type="button"
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                               font-[Poppins] cursor-pointer font-[500] w-full
                               text-base rounded-md hover:bg-white hover:text-[#E90101]
                               ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  {LoadingIcon}
                  Loading...
                </div>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegistrarForm;
